import $ from 'jquery';

$(document).ready(function () {
    $(document).on('click', '.teamMemberTeaser a', function () {
        sessionStorage.setItem('teamMembers:scrollY', String(window.scrollY));
    });

    $(window).on('load', function () {
        const scrollY = sessionStorage.getItem('teamMembers:scrollY');
        if (scrollY && scrollY !== 'undefined' && $('body').hasClass('page-template-our-team')) {
            scrollTo({
                left: 0,
                top: Number(scrollY),
                behavior: 'smooth'
            });
        }
        if ( !$('body').hasClass('single-team-member') ) {
            sessionStorage.removeItem('teamMembers:scrollY');
        }
    });
});